export const environment = {
  production: true,
  name: 'production',
  apiUrl: '',
  aiAgentUrl: 'https://agent.ireport.ch',
  amplitudeApiKey: 'd85039463228e9bf009b9184ec6057ef',
  oldIReportUrl: 'https://app.ireport.ch',
  // PBI #2230 (TC-10): Stripe Pricing Table fuer die Trial-Ende-Seite (von www.ireport.ch
  // uebernommen - dieselbe Table wie auf der Marketing-Seite fuer "Testversion starten").
  stripePublishableKey:
    'pk_live_51Qf0MqE2U1qlwb9QqhftG7TF0RoUJUC1FZLLHrXO0TGkBBAxWF5ClamjZYHgf2KQIZKEr9Psjo1z9uR34x376v4400wNPAlBcZ',
  stripePricingTableId: 'prctbl_1Sj3RWE2U1qlwb9QpC1FsHKN',
};
